import React from "react";
import PropTypes from "prop-types";
import ReactResponsive from "react-responsive";

import { THRESHOLD } from "./constants";

class Default extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function

  render() {
    const { children } = this.props;
    return <ReactResponsive minWidth={THRESHOLD}>{children}</ReactResponsive>;
  }
}

Default.propTypes = {
  children: PropTypes.node,
};

export default Default;
